module.exports = __webpack_public_path__ + "static/media/anatomia3.6d55f9f3.png";